export default __webpack_public_path__ + "static/media/15.8dd8562b.png";